import React from 'react';
import './CategoriesView.css';

function CategoriesView({ categories }) {
  return (
    <div className="categories-management">
      <div className="management-header">
        <div className="section-actions">
          <button className="btn-primary">+ Add Category</button>
        </div>
      </div>

      <div className="categories-grid">
        {categories.map((category) => (
          <div key={category.id} className="category-card">
            <div className="category-header">
              <div className="category-icon-large">{category.icon}</div>
              <h3>{category.name}</h3>
            </div>
            <div className="category-stats">
              <div className="category-stat">
                <span className="stat-label">Products</span>
                <span className="stat-value">{category.productCount}</span>
              </div>
              <div className="category-stat">
                <span className="stat-label">Subcategories</span>
                <span className="stat-value">{category.subCategories}</span>
              </div>
            </div>
            <div className="category-actions">
              <button className="btn-secondary">Edit</button>
              <button className="btn-icon" title="Delete">🗑️</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CategoriesView;
